/**
 * SEPM Documentation.
 * Signed-in users can read the product docs. The X-Translator user manual
 * additionally requires an active X-Translator subscription.
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import RequireXTranslator from "./components/RequireXTranslator";
import { Layout as ManualLayout } from "./manual/components/Layout";
import { HomePage as ManualHomePage } from "./manual/pages/HomePage";
import { DocPageView as ManualDocPage } from "./manual/pages/DocPageView";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import XTranslatorDocIndex from "./pages/XTranslatorDocIndex";
import XTranslatorDocPage from "./pages/XTranslatorDocPage";
import AimsDocIndex from "./pages/AimsDocIndex";
import AimsDocPage from "./pages/AimsDocPage";
function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route element={<RequireAuth />}>
        <Route
          path="/"
          element={
            <Layout>
              <HomePage />
            </Layout>
          }
        />

        <Route path="/docs/x-translator-sw" element={<XTranslatorDocIndex />} />
        <Route path="/docs/x-translator-sw/*" element={<XTranslatorDocPage />} />

        <Route path="/docs/aims-dmg" element={<AimsDocIndex />} />
        <Route path="/docs/aims-dmg/*" element={<AimsDocPage />} />

        <Route element={<RequireXTranslator />}>
          <Route path="/docs/x-translator" element={<ManualLayout />}>
            <Route index element={<ManualHomePage />} />
            <Route path=":pageId" element={<ManualDocPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
